import globalMethods from "@/globalMethods";
import {URLS, RESPONSES} from "@/constants";
import {notify} from "@/plugins/notification";
import i18n from "@/i18n";


export default {
    namespaced: true,
    state: {
        cashiers: [],
        staffs: [],
        deleted_staffs: [],
    },
    mutations: {
        setCashiers(state, data) {
            state.cashiers = data;
        },
        setStaffs(state, data) {
            state.staffs = data;
        },
        setDeletedStaffs(state, data) {
            state.deleted_staffs = data;
        },
        updateStaff(state, staffData) {
            const staff = state.staffs.find(element => element.id === staffData.id);
            staff.name = staffData.name;
            staff.phone = staffData.phone;
            staff.email = staffData.email;
            staff.job_title = staffData.job_title;
            staff.salary_per_day_hour = staffData.salary_per_day_hour;
            staff.salary_per_day_shift = staffData.salary_per_day_shift;
            staff.salary_per_night_hour = staffData.salary_per_night_hour;
            staff.salary_per_night_shift = staffData.salary_per_night_shift;
            staff.salary_per_vacation_day = staffData.salary_per_vacation_day;
            staff.percent_of_sale = staffData.percent_of_sale;
            staff.augmented_user_id = staffData.augmented_user_id;
            staff.shops = staffData.shops;
            staff.company_id = staffData.company_id;
            staff.is_global = staffData.is_global;
            staff.edit_goods_and_characteristics_permission = staffData.edit_goods_and_characteristics_permission;
            staff.delete_goods_and_characteristics_permission = staffData.delete_goods_and_characteristics_permission;
            staff.add_goods_and_characteristics_permission = staffData.add_goods_and_characteristics_permission;
            staff.edit_general_good_characteristics_permission = staffData.edit_general_good_characteristics_permission;
            staff.create_kassa_transactions_permission = staffData.create_kassa_transactions_permission;
            staff.delete_last_kassa_transaction_permission = staffData.delete_last_kassa_transaction_permission;
            staff.delete_kassa_transactions_by_last_day_permission = staffData.delete_kassa_transactions_by_last_day_permission;
            staff.download_kassa_transaction_csv_permission = staffData.download_kassa_transaction_csv_permission;
            staff.create_warehouse_moves_and_supplies_and_delete_good_amounts_permission = staffData.create_warehouse_moves_and_supplies_and_delete_good_amounts_permission;
            staff.view_full_client_base_upload_and_download_clients_permission = staffData.view_full_client_base_upload_and_download_clients_permission;
            staff.delete_and_edit_client_permission = staffData.delete_and_edit_client_permission;
            staff.edit_discount_policy_permission = staffData.edit_discount_policy_permission;
            staff.view_balances_for_past_periods_permission = staffData.view_balances_for_past_periods_permission;
            staff.edit_schedule_permission = staffData.edit_schedule_permission;
            staff.add_payout_permission = staffData.add_payout_permission;
            staff.add_accrual_permission = staffData.add_accrual_permission;
            staff.view_statistics_permission = staffData.view_statistics_permission;
            staff.create_invoices_permission = staffData.create_invoices_permission;
            staff.view_bank_accounts_permission = staffData.view_bank_accounts_permission;
            staff.view_appointments_permission = staffData.view_appointments_permission;
            staff.manage_appointments_permission = staffData.manage_appointments_permission;
            staff.edit_staff_services_permission = staffData.edit_staff_services_permission;
            staff.send_client_notifications_permission = staffData.send_client_notifications_permission;
            staff.manage_ai_concierge_permission = staffData.manage_ai_concierge_permission;
            staff.is_local = staffData.is_local;
        },
        addStaff(state, staffData) {
            state.staffs.unshift(staffData);
        },
        updateStaffActivateStatus(state, data) {
            const staff = state.staffs.find(element => element.id === data.id);
            staff.is_active = data.is_active;
        },
        deleteStaff(state, staffId) {
            state.staffs = state.staffs.filter(staff => staff.id !== staffId);
        },
    },
    actions: {
        async getAllCashiers({commit, rootState}) {
            const {personalData, company} = rootState;
            const url = URLS.MODEL.STAFF.CASHIERS_URL;
            const options = {
                method: "GET",
                credentials: 'include',
                headers: {
                    role: personalData.role,
                    companyId: company.companyData?.token,
                },
            };
            const successfulHandler = (data) => {
                commit("setCashiers", data.data);
                return {successfully: true};
            };
            return globalMethods.sendRequestToGetJson({url, options, successfulHandler});
        },
        async getCashiers({commit, rootState}) {
            const {personalData, company} = rootState;
            const url = URLS.MODEL.STAFF.CASHIERS_URL;
            const options = {
                method: "GET",
                credentials: 'include',
                headers: {
                    role: personalData.role,
                    companyId: company.companyData?.token,
                    shopId: globalMethods.getDataFromLocalStorage("currentCashRegisterId"),
                },
            };
            const successfulHandler = (data) => {
                commit("setCashiers", data.data);
                return {successfully: true};
            };
            return globalMethods.sendRequestToGetJson({url: url, options: options, successfulHandler: successfulHandler});
        },
        async getDeletedStaffs({commit, rootState}) {
            const {personalData, company} = rootState;
            const url = URLS.MODEL.STAFF.STAFFS_URL + "?deleted=true";
            const options = {
                method: "GET",
                credentials: 'include',
                headers: {
                    role: personalData.role,
                    companyId: company.companyData?.token,
                },
            };
            const successfulHandler = (data) => {
                commit("setDeletedStaffs", data.data);
                return {successfully: true};
            };
            return globalMethods.sendRequestToGetJson({url: url, options: options, successfulHandler: successfulHandler});
        },
        async getStaffs({commit, rootState}) {
            const {personalData, company} = rootState;
            const url = URLS.MODEL.STAFF.STAFFS_URL;
            const options = {
                method: "GET",
                credentials: 'include',
                headers: {
                    role: personalData.role,
                    companyId: company.companyData?.token,
                },
            };
            const successfulHandler = (data) => {
                commit("setStaffs", data.data);
                return {successfully: true};
            };
            return globalMethods.sendRequestToGetJson({url: url, options: options, successfulHandler: successfulHandler});
        },
        async updateStaff({commit, rootState}, params) {
            const {personalData, company} = rootState;
            const {staffId, personal_token, name, phone, job_title, comment, salary_per_day_hour, salary_per_day_shift, salary_per_night_hour, salary_per_night_shift, salary_per_vacation_day, percent_of_sale, is_global, is_active, shop_ids, edit_goods_and_characteristics_permission, delete_goods_and_characteristics_permission, add_goods_and_characteristics_permission, edit_general_good_characteristics_permission, create_kassa_transactions_permission, delete_last_kassa_transaction_permission, delete_kassa_transactions_by_last_day_permission, download_kassa_transaction_csv_permission, create_warehouse_moves_and_supplies_and_delete_good_amounts_permission, view_full_client_base_upload_and_download_clients_permission, delete_and_edit_client_permission, edit_discount_policy_permission, view_balances_for_past_periods_permission, edit_schedule_permission, add_payout_permission, add_accrual_permission, view_statistics_permission, create_invoices_permission, view_bank_accounts_permission, view_appointments_permission, manage_appointments_permission, edit_staff_services_permission, send_client_notifications_permission, manage_ai_concierge_permission} = params;
            const url = URLS.MODEL.STAFF.STAFF_URL.replace("<ID>", staffId);
            const options = {
                method: "PUT",
                credentials: "include",
                headers: {
                    "Content-Type": "application/json",
                    "X-CSRFToken": globalMethods.getCookie("csrftoken"),
                    role: personalData.role,
                    companyId: company.companyData?.token,
                },
                body: JSON.stringify({
                    name: name,
                    phone: phone,
                    job_title: job_title,
                    comment: comment,
                    salary_per_day_hour: salary_per_day_hour,
                    salary_per_day_shift: salary_per_day_shift,
                    salary_per_night_hour: salary_per_night_hour,
                    salary_per_night_shift: salary_per_night_shift,
                    salary_per_vacation_day: salary_per_vacation_day,
                    percent_of_sale: percent_of_sale,
                    is_global: is_global,
                    is_active: is_active,
                    shop_ids: shop_ids,
                    edit_goods_and_characteristics_permission: edit_goods_and_characteristics_permission,
                    delete_goods_and_characteristics_permission: delete_goods_and_characteristics_permission,
                    add_goods_and_characteristics_permission: add_goods_and_characteristics_permission,
                    edit_general_good_characteristics_permission: edit_general_good_characteristics_permission,
                    create_kassa_transactions_permission: create_kassa_transactions_permission,
                    delete_last_kassa_transaction_permission: delete_last_kassa_transaction_permission,
                    delete_kassa_transactions_by_last_day_permission: delete_kassa_transactions_by_last_day_permission,
                    download_kassa_transaction_csv_permission: download_kassa_transaction_csv_permission,
                    create_warehouse_moves_and_supplies_and_delete_good_amounts_permission: create_warehouse_moves_and_supplies_and_delete_good_amounts_permission,
                    view_full_client_base_upload_and_download_clients_permission: view_full_client_base_upload_and_download_clients_permission,
                    delete_and_edit_client_permission: delete_and_edit_client_permission,
                    edit_discount_policy_permission: edit_discount_policy_permission,
                    view_balances_for_past_periods_permission: view_balances_for_past_periods_permission,
                    edit_schedule_permission: edit_schedule_permission,
                    add_payout_permission: add_payout_permission,
                    add_accrual_permission: add_accrual_permission,
                    view_statistics_permission: view_statistics_permission,
                    create_invoices_permission: create_invoices_permission,
                    view_bank_accounts_permission: view_bank_accounts_permission,
                    view_appointments_permission: view_appointments_permission,
                    manage_appointments_permission: manage_appointments_permission,
                    edit_staff_services_permission: edit_staff_services_permission,
                    send_client_notifications_permission: send_client_notifications_permission,
                    manage_ai_concierge_permission: manage_ai_concierge_permission,
                    ...(personal_token ? {personal_token} : {}),
                })
            };
            const successfulHandler = (data) => {
                commit("updateStaff", data["staff_data"]);
                commit("salaryReport/addOrUpdateSalaryReports", data["salary_report_data"], {root: true});
                notify(i18n.global.t("Staff successfully updated"));
                return {successfully: true};
            };
            return globalMethods.sendRequestToGetJson({url: url, options: options, successfulHandler: successfulHandler});
        },
        async updateStaffsOrder({commit, rootState}, data) {
            const {personalData, company} = rootState;
            const {target_staff_id, to_staff_id, mode} = data;
            const url = URLS.MODEL.STAFF.STAFFS_URL;
            const options = {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                    "X-CSRFToken": globalMethods.getCookie("csrftoken"),
                    role: personalData.role,
                    companyId: company.companyData?.token,
                },
                credentials: "include",
                body: JSON.stringify({
                    target_staff_id: target_staff_id,
                    to_staff_id: to_staff_id,
                    mode: mode,
                }),
            };
            const successfulHandler = (data) => {
                commit("setStaffs", data.data);
                notify(i18n.global.t("Staff order successfully updated"));
                return {successfully: true};
            };
            return globalMethods.sendRequestToGetJson({url: url, options: options, successfulHandler: successfulHandler});
        },
        async createStaff({commit, rootState}, params) {
            const {personalData, company} = rootState;
            const {name, phone, token, is_local, job_title, is_global, shop_ids, comment, salary_per_day_shift, salary_per_day_hour, salary_per_night_shift, salary_per_night_hour, salary_per_vacation_day, percent_of_sale, edit_goods_and_characteristics_permission, delete_goods_and_characteristics_permission, add_goods_and_characteristics_permission, edit_general_good_characteristics_permission, create_kassa_transactions_permission, delete_last_kassa_transaction_permission, delete_kassa_transactions_by_last_day_permission, download_kassa_transaction_csv_permission, create_warehouse_moves_and_supplies_and_delete_good_amounts_permission, view_full_client_base_upload_and_download_clients_permission, delete_and_edit_client_permission, edit_discount_policy_permission, view_balances_for_past_periods_permission, edit_schedule_permission, add_payout_permission, add_accrual_permission, view_statistics_permission, create_invoices_permission, view_bank_accounts_permission, view_appointments_permission, manage_appointments_permission, edit_staff_services_permission, send_client_notifications_permission, manage_ai_concierge_permission} = params;
            const url = URLS.MODEL.STAFF.STAFFS_URL;
            const options = {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "X-CSRFToken": globalMethods.getCookie("csrftoken"),
                    role: personalData.role,
                    companyId: company.companyData?.token,
                },
                credentials: "include",
                body: JSON.stringify({
                    personal_token: is_local ? undefined : token,
                    is_local: is_local || false,
                    name: name,
                    phone: phone,
                    job_title: job_title,
                    comment: comment,
                    salary_per_day_hour: salary_per_day_hour,
                    salary_per_day_shift: salary_per_day_shift,
                    salary_per_night_hour: salary_per_night_hour,
                    salary_per_night_shift: salary_per_night_shift,
                    salary_per_vacation_day: salary_per_vacation_day,
                    percent_of_sale: percent_of_sale,
                    is_global: is_global,
                    shop_ids: shop_ids,
                    edit_goods_and_characteristics_permission: edit_goods_and_characteristics_permission,
                    delete_goods_and_characteristics_permission: delete_goods_and_characteristics_permission,
                    add_goods_and_characteristics_permission: add_goods_and_characteristics_permission,
                    edit_general_good_characteristics_permission: edit_general_good_characteristics_permission,
                    create_kassa_transactions_permission: create_kassa_transactions_permission,
                    delete_last_kassa_transaction_permission: delete_last_kassa_transaction_permission,
                    delete_kassa_transactions_by_last_day_permission: delete_kassa_transactions_by_last_day_permission,
                    download_kassa_transaction_csv_permission: download_kassa_transaction_csv_permission,
                    create_warehouse_moves_and_supplies_and_delete_good_amounts_permission: create_warehouse_moves_and_supplies_and_delete_good_amounts_permission,
                    view_full_client_base_upload_and_download_clients_permission: view_full_client_base_upload_and_download_clients_permission,
                    delete_and_edit_client_permission: delete_and_edit_client_permission,
                    edit_discount_policy_permission: edit_discount_policy_permission,
                    view_balances_for_past_periods_permission: view_balances_for_past_periods_permission,
                    edit_schedule_permission: edit_schedule_permission,
                    add_payout_permission: add_payout_permission,
                    add_accrual_permission: add_accrual_permission,
                    view_statistics_permission: view_statistics_permission,
                    create_invoices_permission: create_invoices_permission,
                    view_bank_accounts_permission: view_bank_accounts_permission,
                    view_appointments_permission: view_appointments_permission,
                    manage_appointments_permission: manage_appointments_permission,
                    edit_staff_services_permission: edit_staff_services_permission,
                    send_client_notifications_permission: send_client_notifications_permission,
                    manage_ai_concierge_permission: manage_ai_concierge_permission,
                })
            };
            const successfulHandler = (data) => {
                commit("addStaff", data.data);
                notify(i18n.global.t("Staff successfully added to your company"));
                return {successfully: true};
            };
            const errorHandler = (data) => {
                if (data?.detail === RESPONSES.ALREADY_EXIST) {
                    notify(i18n.global.t("This staff member is already in your company"), "red", 5000);
                    return {successfully: false, detail: RESPONSES.ALREADY_EXIST};
                }
                if (data[0] === RESPONSES.NOT_VALID) {
                    return {successfully: false, detail: RESPONSES.NOT_VALID};
                }
                return {successfully: false, detail: data};
            };
            return globalMethods.sendRequestToGetJson({url: url, options: options, successfulHandler: successfulHandler, errorHandler: errorHandler});
        },
        async updateStaffActivateStatus({commit, rootState}, params) {
            const {personalData, company} = rootState;
            const {staffId, is_active} = params;
            const url = URLS.MODEL.STAFF.STAFF_URL.replace("<ID>", staffId);
            const options = {
                method: "PATCH",
                credentials: "include",
                headers: {
                    "Content-Type": "application/json",
                    "X-CSRFToken": globalMethods.getCookie("csrftoken"),
                    role: personalData.role,
                    companyId: company.companyData?.token,
                },
                body: JSON.stringify({
                    is_active: is_active,
                })
            };
            const successfulHandler = (data) => {
                commit("updateStaffActivateStatus", data.data);
                if (is_active) notify(i18n.global.t("Staff successfully added to hidden"));
                else notify(i18n.global.t("Staff successfully removed from hidden"));
                return {successfully: true};
            };
            return globalMethods.sendRequestToGetJson({url: url, options: options, successfulHandler: successfulHandler});
        },
        async deleteStaff({commit, rootState}, staffId) {
            const {personalData, company} = rootState;
            const url = URLS.MODEL.STAFF.STAFF_URL.replace("<ID>", staffId);
            const options = {
                method: "DELETE",
                headers: {
                    "Content-Type": "application/json",
                    "X-CSRFToken": globalMethods.getCookie("csrftoken"),
                    role: personalData.role,
                    companyId: company.companyData?.token,
                },
                credentials: "include",
            };
            const successfulHandler = () => {
                commit("deleteStaff", staffId);
                notify(i18n.global.t("Staff successfully deleted"));
                return {successfully: true};
            };
            return globalMethods.sendRequestToGetJson({url: url, options: options, successfulHandler: successfulHandler});
        },
    }
};